import { Component } from '@angular/core';

@Component({
  selector: 'app-activite-parcours-objectif',
  imports: [],
  templateUrl: './activite-parcours-objectif.component.html',
})
export class ActiviteParcoursObjectifComponent {}
